import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../../store/action/post";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MultiSelectReact from "multi-select-react";
import localStorage from "../../../utils/local-storage";
import * as _ from "lodash";
import Input from "../../../components/input/Input";
import slug from "@sindresorhus/slugify";

const CategoryItem = ({
  category,
  level,
  selectCategory,
  makePrimary,
  currentPost,
  channels
}) => {
  const { categories, primary_category } = currentPost || {};
  let checked = false;
  if (primary_category && primary_category._id === category._id) {
    checked = true;
  } else {
    if (categories) {
      checked = categories.find((cate) => cate._id === category._id)
        ? true
        : false;
    }
  }
  const channel = channels ? channels.filter((obj) => obj.increment_id == category.channel) : null;
  return (
    <React.Fragment>
      <li className={`category-level-${level}`}>
        <div className="icheck-success d-inline ml-2">
          <input
            id={`category-id-${category._id}`}
            type="checkbox"
            name="category"
            checked={checked}
            disabled={primary_category && primary_category._id === category._id}
            onChange={(event) => {
              selectCategory();
            }}
          />
          <label htmlFor={`category-id-${category._id}`}></label>
        </div>
        <span className="text">{channel && channel[0].increment_id != 1 ? "[ " + channel[0].label + " ] " : ""}{category.name}</span>
        {level === 0 &&
          checked &&
          (!primary_category ||
            (primary_category && primary_category._id !== category._id)) && (
            <strong
              onClick={() => makePrimary(category)}
              className="text-sm color-palette cursor-pointer color-ed1c24"
            >
              Đặt làm chuyên mục chính
            </strong>
          )}
        {level === 0 &&
          primary_category &&
          primary_category._id === category._id && (
            <small className="badge badge-success"> Chuyên mục chính</small>
          )}
      </li>

      {/* {category.categories &&
        category.categories.map((childCategory, index) => (
          <CategoryItem
            key={`category-id-${index}-${childCategory.id}`}
            category={childCategory}
            level={level + 1}
            selectCategory={() => selectCategory(childCategory)}
          />
        ))} */}
    </React.Fragment>
  );
};

const CategoryTab = (props) => {
  const {
    layoutName,
    checkClass,
    post,
    post: { currentPost = {} },
    config,
    config: { listCategory = [] },
    setCurrentPost,
    checkRequireData
  } = props;
  const [categories, setCategories] = React.useState([]);
  const user = localStorage.get("_user");
  const userIdCategories = user.categories.map((cate) => cate._id);

  const makePrimary = (cate) => {
    currentPost.primary_category = cate;
    currentPost.channel = cate.channel;
    setCurrentPost(currentPost);
  };

  const selectCategory = (category) => {
    const currentCategories = currentPost.categories || [];
    const find = currentCategories.find((cate) => cate._id === category._id);
    if (find) {
        if(!currentPost.primary_category){
            // console.log(currentPost.primary_category);
            currentPost.primary_category = category;
        }
      currentPost.categories = currentCategories.filter(
        (cate) => cate._id !== category._id
      );
      if (
        currentPost.primary_category &&
        currentPost.primary_category._id === category._id
      ) {
        currentPost.primary_category = null;
        if(!currentPost.categories || currentPost.categories.length == 0){
          currentPost.channel = null;
        }
      }

      
    } else {
        // không có chuyên mục và không có chuyên mục chính thì click đầu tiên set up chuyên mục chính
      if(!currentPost.primary_category){
        currentPost.primary_category = category;
        // set channel cho post
        currentPost.channel = category.channel;
      }
      // kiểm tra chuyên mục mới tick có channel khác channel 1
      if(category.channel != 1){
        // nếu category mới tick có channel khác 1 thì kiểm tra trong list categories có category nào cùng channel chưa
        // nếu có thì không cho tick
        // nếu không thì cho tick và bỏ vào currentPost.categories
        const cateChannelFilter = currentPost.categories ? currentPost.categories.filter((cate) => cate.channel == category.channel) : null;
        if(cateChannelFilter && cateChannelFilter.length > 0){
          return;
        }
        else{
          currentPost.categories = [...currentCategories, category];
        }
      }else{
        currentPost.categories = [...currentCategories, category];
      }
    }
    // console.log({ currentPost });

    setCurrentPost(currentPost);
    checkRequireData(currentPost, 5);
  };

  const getValidCategory = (editor_type) => {
    if (listCategory) {
      const CATEGORIES_FOR_NORMAL_EDITOR_TYPE = ["normal", "special", "mini"];
      const validCategory = listCategory.filter((cate) => {
        if (cate.status) {
          // if (
          //   !cate.editor_type &&
          //   CATEGORIES_FOR_NORMAL_EDITOR_TYPE.includes(editor_type) &&
          //   userIdCategories.includes(cate._id)
          // ) {
          //   return cate;
          // }
          if (
            cate.editor_type &&
            cate.editor_type.split(",").includes(editor_type) &&
            userIdCategories.includes(cate._id)
          ) {
            return cate;
          }
        }
      });
      return validCategory;
    }
    return [];
  };

  React.useEffect(() => {
    if (listCategory) {
      const { editor_type } = currentPost;
      const validCategory = getValidCategory(editor_type);
      setCategories(validCategory);
      // set default categories & primary_category for post;
      if (currentPost && !currentPost.categories && validCategory.length > 0 && currentPost.primary_category && currentPost.primary_category.editor_type.indexOf(editor_type) < 0 ) {
        currentPost.primary_category = null;
        if(currentPost.categories && currentPost.categories.length > 2){

        }
        else{
            currentPost.categories = []
        }
        // currentPost.categories = [validCategory[0]];
        // currentPost.primary_category = validCategory[0];
        setCurrentPost(currentPost);
        checkRequireData(currentPost, 5);
      }
    }
  }, [listCategory]);

  React.useEffect(() => {
    const { editor_type } = post.currentPost;
    const validCategory = getValidCategory(editor_type);
    setCategories(validCategory);
    if (currentPost && validCategory.length > 0 && currentPost.primary_category && currentPost.primary_category.editor_type.indexOf(editor_type) < 0 ) {
        currentPost.primary_category = null;
        if(currentPost.categories && currentPost.categories.length > 2){

        }
        else{
            currentPost.categories = []
        }
        
        // console.log(currentPost);
        // currentPost.categories = [validCategory[0]];
        // currentPost.primary_category = validCategory[0];
        setCurrentPost(currentPost);
        checkRequireData(currentPost, 5);
      }
  }, [post]);

  return (
    <div>
      <div className={layoutName !== "layout-pc" ? "row card pb-3" : ""}>
        {layoutName !== "layout-pc" && (
          <div className={"card-header col-12 " + checkClass}>
            <h4 className="card-title">Chuyên mục</h4>
            <div className="card-tools">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="collapse"
              >
                <i className="fas fa-minus"></i>
              </button>
            </div>
          </div>
        )}
        <div
          className="card-body col-12 direct-chat-messages"
          // style={{ padding: "1.25rem" }}
        >
          <div className="form-group">
            {/* <div className="row">
              <label>Chuyên mục </label>
            </div> */}

            <ul className="todo-list ui-sortable" data-widget="todo-list">
              {categories.map((cate, index) => (
                  <CategoryItem
                    key={`category-id-${index}-${cate.id}`}
                    currentPost={currentPost}
                    category={cate}
                    level={0}
                    selectCategory={() => selectCategory(cate)}
                    makePrimary={makePrimary}
                    channels={config.channels}
                  />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (store) => {
    return {
      post: store.post,
      config: store.config,
      loginInfo: store.loginInfo,
    };
  },
  (dispatch) => {
    return {
      setCurrentPost: (value) => {
        dispatch(postActions.setCurrentPost(value));
      },
    };
  }
)(CategoryTab);